import { useQuery } from 'react-query';
import {
  getAdaptedFictionDetail,
  type AdaptedFictionDetailResponse
} from '../../services/sceneService';
import { SCENE_QUERY_KEYS } from '../queryKeys';

export function useGetAdaptedFictionDetail(adaptedFictionId?: string | null) {
  return useQuery<AdaptedFictionDetailResponse, Error>(
    SCENE_QUERY_KEYS.adaptedFictionDetail(adaptedFictionId ?? ''),
    () => getAdaptedFictionDetail({ adaptedFictionId: adaptedFictionId ?? '' }),
    {
      enabled: Boolean(adaptedFictionId)
    }
  );
}
